module.exports = __webpack_public_path__ + "8d2f007aae4f4603bbbe1e64b487d71a.png";